<template>
	<div class="learningrecords">
		<div class="usercontexttop">
			<div>文章发布
			</div>
			<div class="btnpage" v-if="pages>1">
				<a href="javascript:void(0);" class="pagebtn1 mr" @click="sy">首页</a>
				<a href="javascript:void(0);" class="pagebtn1 mr" @click="syy">上一页</a>
				<a href="javascript:void(0);" class="pagebtn2 lebtn2" v-if="pageslist!=null" v-for="i in pageslist"
					:data-id="i" @click="selectpage(i)">{{i}}</a>
				<a href="javascript:void(0);" class="pagebtn1 ml" @click="xyy">下一页</a>
				<a href="javascript:void(0);" class="pagebtn1 ml" @click="wy">尾页</a>
			</div>
		</div>
		<div class="borderlean">
			<div class="itemall" v-if="!addwzshow">
				<a class="showboxssss" href="javascript:void(0);" @click="showfbwz">
					<div>点击发布一篇文章</div>
				</a>
			</div>
			<div class="itemall" v-else>
				<input class="titlewz" v-model="titlewz" type="text" placeholder="请输入标题" />
				<textbox ref="textbox"></textbox>
				<div style="padding-bottom: 0.5rem;text-align: right;">
					<a href="javascript:void(0);" class="wzfbsubmit" @click="submitwz"><div>提交发布信息</div></a>
					<a href="javascript:void(0);" class="wzfbsubmit" @click="addwzshow = false"><div>取消</div></a>
				</div>
			</div>
		</div>
		<div class="borderlean">
			<div class="itemall" v-if="list.length===0">
				<div class="ttttttt">当前还未发布任何文章哦,快去发布一篇吧~</div>
			</div>
			<div class="contextitem" v-for="item in list" :key="item.id">
				<div class="iitt2">
					<!-- {{this.list.cmsKnowledgePoints[0].title}} -->
					<div class="texttitle">
						<span style="width: 60%;"><img src="../../assets/images/usertxt.png" />&ensp;{{item.title}}</span>
						<span class="aaaaaaaaaaa" style="width: 25%;text-align: center;"><img src="../../assets/images/usersj.png" />&ensp;{{setData(item.createdAt)}}</span>
						<span v-if="item.type==='1'" class="ysh" style="color: rgba(53,98,78,1);font-weight: bold;width: 15%;text-align: right;">审核已通过</span>
						<span v-else-if="item.type==='0'" class="wsh" style="color: rgba(197,141,68,1);font-weight: bold;width: 15%;text-align: right;">审核中</span>
						<span v-else class="wsh" style="color: rgba(167,58,41,1);font-weight: bold;width: 15%;text-align: right;">审核未通过</span>
					</div>
					<div class="ttxt">
						{{item.content}}
					</div>
				</div>
			</div>
		</div>
		<div class="btnpage2" v-if="pages>1">
			<a href="javascript:void(0);" class="pagebtn11" @click="sy"><span>首页</span></a>
			<a href="javascript:void(0);" class="pagebtn11" @click="syy"><span>上一页</span></a>
			<a href="javascript:void(0);" class="pagebtn22 lebtn" v-if="pageslist!=null" v-for="i in pageslist"
				:data-id="i" @click="selectpage(i)"><span>{{i}}</span></a>
			<a href="javascript:void(0);" class="pagebtn11" @click="xyy"><span>下一页</span></a>
			<a href="javascript:void(0);" class="pagebtn11" @click="wy"><span>尾页</span></a>
		</div>

	</div>
		<popup ref="popups" :types="popuptype" :message="message"></popup>

</template>

<script>
	import axios from 'axios'
	import textbox from './textbox.vue'
	import popup from '../popups/popup.vue'
	export default {
		components: {
			textbox,
			popup
		},
		name: 'learningrecords',
		data() {
			return {
				popuptype: "success",
				message: "",
				token: this.$store.state.token, //token
				userid: this.$store.state.userid, //id
				list: [],
				pageNum: 1,
				pageSize: 20,
				pages: 1, //总页数
				pageslist: null, //只显示五页
				addwzshow: false,
				textboxhtml: "",
				titlewz: null
			}
		},
		created() {
			this.getlist()
		},
		methods: {
			setData(value){
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return  y + '年' + MM + '月' + d + '日 ' + h + ':' + m + ':' + s
			},
			getlist() {
				new Promise((resolve, reject) => {
					axios({
						url: this.$api.commonUrl + 'posts',
						method: 'GET',
						params: {
							"userId": this.userid,
							"pageSize": this.pageSize,
							"pageNum": this.pageNum,
							"categoryId": "13"
						},
						headers: {
							"Authorization": "Bearer " + this.token
						}
					}).then(res => {
						if (res.data.code == '200') {
							this.list = res.data.data.list
							this.pages = res.data.data.pages
							console.log(this.list)
							if (parseInt(res.data.data.pages) >= 5) {
								for (let i = 1; i <= 5; i++) {
									if (this.pageNum > 2) {
										this.pageslist = [this.pageNum - 2, this.pageNum - 1, this.pageNum,
											this.pageNum + 1, this.pageNum + 2
										]
									}
									if (this.pageNum <= 2) {
										this.pageslist = [1, 2, 3, 4, 5]
									}
									if (this.pageNum >= this.pages - 2) {
										this.pageslist = [this.pages - 4, this.pages - 3, this.pages - 2,
											this.pages - 1, this.pages
										]
									}
								}
							} else if (parseInt(res.data.data.pages) < 5) {
								let newlist = []
								for (let i = 1; i <= parseInt(res.data.data.pages); i++) {
									newlist.push(i)
								}
								this.pageslist = newlist
							}
							resolve()
						}
					}).catch(err => {
						console.log(err)
					})
				}).then((res) => {
					this.pushclass()
				})
			},
			pushclass() {
				let allpageelement = document.getElementsByClassName('lebtn')
				let allpageelement2 = document.getElementsByClassName('lebtn2')
				for (let i = 0; i < allpageelement.length; i++) {
					if (parseInt(allpageelement[i].getAttribute('data-id')) === this.pageNum) {
						allpageelement[i].className = 'pagebtn22 lebtn pageselect'
						allpageelement2[i].setAttribute("style", "color: #FFFFFF;")
					} else {
						allpageelement[i].className = 'pagebtn22 lebtn'
						allpageelement2[i].setAttribute("style", "color:#d49f79;")
					}
				}
			},
			selectpage(i) {
				this.pageNum = i
				this.getlist()
			},
			sy() {
				if (this.pageNum != 1) {
					this.pageNum = 1
					this.getlist()
				}
			},
			syy() {
				if (this.pageNum > 1) {
					this.pageNum -= 1
					this.getlist()
				}
			},
			xyy() {
				if (this.pageNum < this.pages) {
					this.pageNum += 1
					this.getlist()
				}
			},
			wy() {
				if (this.pageNum != this.pages) {
					this.pageNum = this.pages
					this.getlist()
				}
			},
			indest(id) {
				this.$router.push({
					path: '/knowledgebasedetails',
					query: {
						id: id
					}
				})
			},
			showfbwz() {
				this.addwzshow = true
			},
			show(mes, type) {
				this.popuptype = type
				this.message = mes
				this.$refs.popup.popupshow()
			},
			submitwz() {
				if (this.titlewz) {
					if (this.$refs.textbox.gethtml()) {
						this.addwzshow = false
						axios({
							url: this.$api.commonUrl + "posts/add",
							method: "POST",
							data: {
								title: this.titlewz,
								imageId: "",
								videoId: "",
								content: this.$refs.textbox.gethtml(),
								cmsCategoryList: [{
									id: "13"
								}],
							},
							headers: {
								Authorization: "Bearer " + this.token,
							},
						}).then((res) => {
							if (res.data.code == "200") {} else {
								console.log()
							}
							this.getlist()
							this.titlewz = null
						}).catch((err) => {
							console.log(err);
						})
					} else {
						this.popuptype = 'warning'
						this.message = "请输入内容"
						this.$refs.popups.popupshow()
					}
				} else {
					this.popuptype = 'warning'
					this.message = "请输入标题"
					this.$refs.popups.popupshow()
				}
			}
		}
	}
</script>

<style scoped>
	.itemall .showboxssss {
		display: block;
		width: 15rem;
		height: 2.5rem;
		background: #a73a29;
		text-align: center;
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		color: #FFFFFF;
	}

	.itemall .showboxssss div {
		border: 1px solid #FFFFFF;
		margin: 1px;
		height: calc(2.5rem - 4px);
		line-height: calc(2.5rem - 4px);
		font-size: 1rem;
	}
	#textbox{
		margin: 0.5rem;
		margin-top: 0px;
	}
	.itemall {
		background: #f7e9d3;
		height: auto;
		position: relative;
		min-height: 8rem;
	}
	.wzfbsubmit div{
		border: 1px solid #FFFFFF;
		margin: 1px;
		height: calc(2.5rem - 4px);
		line-height: calc(2.5rem - 4px);
	}
	.wzfbsubmit:first-child{
		display: inline-block;
		background: #a73a29;
		width: 13rem;
		height: 2.5rem;
		color: #FFFFFF;
		border: none;
		font-size: 1rem;
		text-align: center;
		margin-right: 1rem;
	}
	.wzfbsubmit:last-child{
		display: inline-block;
		background: #cea57d;
		width: 13rem;
		height: 2.5rem;
		color: #FFFFFF;
		border: none;
		font-size: 1rem;
		text-align: center;
		margin-right: 0.5rem;
	}

	.titlewz {
		border: none;
		outline: none;
		width: calc(100% - 2rem);
		height: 3rem;
		margin: 0.5rem;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		font-size: 1.142857rem;
	}

	.fbwztitle {
		height: 5rem;
		text-align: center;
		font-size: 2.2rem;
		line-height: 5rem;
		font-family: 'STXingkai';
		border-bottom: 1px dashed #5f3519;
		color: #5f3519;
		margin: 1rem;
		letter-spacing: 0.5rem;
	}

	.texts {
		position: absolute;
		top: 2rem;
		left: 2rem;
		right: 2rem;
		bottom: 2rem;
		background: rgba(0, 0, 0, 0);
	}

	.insertwz {
		position: fixed;
		width: 70rem;
		height: calc(70rem * 0.87);
		background: url(../../assets/images/tcbag.png) no-repeat;
		background-size: 100% 100%;
		margin: auto;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.closebtnwz {
		position: absolute;
		right: -3rem;
		top: -3rem;
		width: 3rem;
		height: 3rem;
	}

	.bagbagwz {
		position: fixed;
		background: rgba(0, 0, 0, 0.5);
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		z-index: 100;
	}

	.closebtnwz img {
		width: 3rem;
		height: 3rem;
		display: block;
	}

	.wzfubtn {
		font-size: 1rem;
		color: #FFFFFF;
	}

	.learningrecords {
		background: #FFFFFF;
		border: 1px solid #a2693f;
	}

	.learningrecords .iitt1 {
		height: 2rem;
		line-height: 2rem;
	}

	.learningrecords .iitt2 {
		height: 4rem;
		line-height: 2rem;
	}

	.learningrecords .iitt1 img,
	.learningrecords .iitt2 img {
		width: 1.3rem;
		height: 1.3rem;
		display: block;
		float: left;
		margin-top: 0.35rem;
	}

	.learningrecords .contextitem {
		padding: 0.5rem;
		border-bottom: 1px dashed #dbb48a;
	}

	.learningrecords .contextitem:nth-child(even) {
		background: #faf7f3;
	}

	.learningrecords .contextitem:last-child {
		border: none;
	}

	.learningrecords .iitt1 {
		margin-bottom: 0.2rem;
	}

	.learningrecords .iitt1 p {
		width: calc(100% - 2.5rem);
		height: auto;
		margin-left: 0.5rem;
		float: left;
		color: #896247;
		font-size: 0.9rem;
	}

	.learningrecords .ttxt {
		font-size: 1rem;
		width: calc(80% - 2.5rem);
		height: 2rem;
		margin-left: 0.5rem;
		line-height: 2rem;
		float: left;
		color: #7d7774;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}

	.learningrecords .lean {
		display: block;
		width: 8rem;
		height: 2rem;
		background: #FFFFFF;
		margin-top: 2rem;
		margin-bottom: 1rem;
		text-decoration: none;
		color: #FFFFFF;
		text-align: center;
		line-height: calc(2rem - 2px);
		border: 1px solid #a73a29;
		position: relative;
		font-size: 0.9rem;
	}

	.learningrecords .lean span {
		background: #a73a29;
		position: absolute;
		top: 1px;
		left: 1px;
		right: 1px;
		bottom: 1px;
	}

	.learningrecords .borderlean {
		border: 1px solid #a2693f;
		margin: 1px;
	}

	.learningrecords .texttitle {
		color: #24211f;
		font-size: 1.1rem;
		display: flex;
	}

	.learningrecords .textspan {
		color: #a72958;
	}

	@media screen and (max-width: 1920px) {
		html {
			font-size: 16px;
		}
	}

	.ysh {
		color: #67c23a;
		float: right;
	}

	.wsh {
		color: #a73a29;
		float: right;
	}
	
	.ttttttt{
		line-height: 650px;
		height: 650px;
		text-align: center;
		width: 100%;
		color: #d49f79;
		font-size: 1.285714rem;
	}
	.aaaaaaaaaaa{
		display: flex;
		justify-content: center;
		color: #783d1a;
		font-size: 0.95rem;
	}
	.aaaaaaaaaaa img{
		float: none !important;
	}
</style>
